export default __webpack_public_path__ + "static/media/icon-flight.4d2c5fc4.svg";